import gql from 'graphql-tag'

// Market-level flag (returns the new isBase value). Unlike the audience-member
// mutations this does not change audience content, so it intentionally does
// not fire recordAudienceChangedForIRSNotification.
export const SET_BASE_MARKET_V2 = gql`
  mutation setBaseMarketV2($input: SetBaseMarketV2Input!) {
    setBaseMarketV2(input: $input)
  }
`
